import _ from 'underscore';

export function createErrorMessage(error) {
  try {
    if (_.isString(error)) {
      return error;
    }

    if (_.isError(error)) {
      return `${error.name}: ${error.message}. ${error.stack}`;
    }

    if (_.isObject(error)) {
      return JSON.stringify(error);
    }

    return error.toString();
  } catch (e) {
    return 'Error can not be serialized';
  }
}
